import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { CreditorLightInfo } from
  '@feature/_app_modules/mojo-for-suppliers/mfs-shared/creditors/models/creditor-light-info';

@Injectable({
  providedIn: 'root'
})
export class CreditorHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlProvider: UrlBuilderService) {
  }

  getAllCreditors() {
    const url = this.urlProvider.getUrl('creditors');
    return this.http.get<CreditorLightInfo[]>(url);
  }

  getSupplierCreditors( supplierRef: number) {
    const url = this.urlProvider.getUrl( `suppliercreditors/${supplierRef}`);
    return this.http.get<CreditorLightInfo[]>(url);
  }
  
  getOtherCreditors() {
    const url = this.urlProvider.getUrl('creditors/other');
    return this.http.get<CreditorLightInfo[]>(url);
  }

}
